import { useState } from "react";

export default function LoginPage({ onLogin }) {
  const [name,     setName]     = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError]    = useState("");
  const [loading,  setLoading]  = useState(false);
  const [locked,   setLocked]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (locked) return;
    setError("");
    setLoading(true);
    try {
      const res  = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name: name.trim(), password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || "Login failed");
        if (data.locked) setLocked(true);
      } else {
        onLogin(data.user);
      }
    } catch {
      setError("Could not connect to server. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = (disabled) => ({
    width: "100%",
    padding: "11px 14px",
    border: "1.5px solid #dde2ed",
    borderRadius: 8,
    fontSize: 14,
    boxSizing: "border-box",
    background: disabled ? "#f7f8fa" : "#fff",
    color: "#1a1a2e",
    outline: "none",
    transition: "border-color 0.15s",
  });

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "Arial, sans-serif",
      background: "linear-gradient(160deg, #12285a 0%, #1a3a6e 55%, #1e4481 100%)",
      position: "relative",
      overflow: "hidden",
    }}>
      {/* Subtle background texture circles */}
      <div style={{ position: "absolute", top: -120, right: -120, width: 400, height: 400, borderRadius: "50%", background: "rgba(255,255,255,0.04)", pointerEvents: "none" }} />
      <div style={{ position: "absolute", bottom: -80, left: -80, width: 300, height: 300, borderRadius: "50%", background: "rgba(255,255,255,0.03)", pointerEvents: "none" }} />

      <div style={{
        background: "#fff",
        borderRadius: 16,
        padding: "44px 40px 36px",
        width: "100%",
        maxWidth: 400,
        boxShadow: "0 24px 64px rgba(0,0,0,0.28)",
        position: "relative",
      }}>
        {/* Logo + heading */}
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <img
            src="/logo.png"
            alt="Dynamic Health IT"
            style={{ height: 52, objectFit: "contain", marginBottom: 16 }}
            onError={e => { e.target.style.display = "none"; }}
          />
          <div style={{ fontSize: 18, fontWeight: 700, color: "#1a3a6e", letterSpacing: "-0.3px" }}>
            Agreement Builder
          </div>
          <div style={{ fontSize: 12, color: "#aaa", marginTop: 4 }}>
            Sign in to continue
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 14 }}>
            <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#555", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.04em" }}>
              Full name
            </label>
            <input
              type="text"
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="e.g. Sayge Sims"
              disabled={locked}
              required
              style={inputStyle(locked)}
              onFocus={e => { e.target.style.borderColor = "#1a3a6e"; }}
              onBlur={e => { e.target.style.borderColor = "#dde2ed"; }}
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#555", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.04em" }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Enter your password"
              disabled={locked}
              required
              style={inputStyle(locked)}
              onFocus={e => { e.target.style.borderColor = "#1a3a6e"; }}
              onBlur={e => { e.target.style.borderColor = "#dde2ed"; }}
            />
          </div>

          {error && (
            <div style={{
              background: locked ? "#fff8f0" : "#fef2f2",
              color: locked ? "#b45309" : "#c62828",
              border: `1px solid ${locked ? "#fcd34d" : "#fca5a5"}`,
              borderRadius: 8,
              padding: "10px 14px",
              fontSize: 13,
              marginBottom: 16,
              lineHeight: 1.5,
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading || locked}
            style={{
              width: "100%",
              padding: "12px",
              background: locked ? "#ccc" : "linear-gradient(160deg, #12285a 0%, #1a3a6e 100%)",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              fontSize: 15,
              fontWeight: 600,
              cursor: locked ? "not-allowed" : "pointer",
              letterSpacing: "-0.1px",
              boxShadow: locked ? "none" : "0 4px 12px rgba(26,58,110,0.3)",
            }}
          >
            {loading ? "Signing in…" : locked ? "Account locked" : "Sign in →"}
          </button>
        </form>

        <p style={{ textAlign: "center", fontSize: 11, color: "#ccc", marginTop: 24, marginBottom: 0 }}>
          Dynamic Health IT, Inc. · Internal use only
        </p>
      </div>
    </div>
  );
}
